import MegaMenu from './components/menus/megaMenu';
import SecondaryMenu from './components/menus/secondaryMenu';
import ExtendSizeChart from './components/extendSizeChart';
import VariationSelector from './components/variationSelector';
import CategoryNavigation from './components/menus/categoryNavigation';
import './components/product-category-animation-polyfill';

document.addEventListener( 'DOMContentLoaded', () => {
	const megaMenu = new MegaMenu();
	const secondaryMenu = new SecondaryMenu();
	const sizeChart = new ExtendSizeChart();

	megaMenu.init();
	secondaryMenu.init();
	sizeChart.init();
	new VariationSelector();
	new CategoryNavigation();
} );

// Enhanced Product Slider
import './components/enhancedProductSlider';
